<div class="loader__container">
  @if(message()) {
  <span class="mb-3">{{ message() }}</span>
  }
  <i-loader></i-loader>
</div>
